import type { RouteRecordRaw } from 'vue-router'

export const addRoutes = (
  routes: RouteRecordRaw[],
  routesToAdd: RouteRecordRaw[],
): RouteRecordRaw[] => {
  routesToAdd.forEach((route) => routes.push(route))
  return routes
}
